import React, { ReactNode } from 'react';

import AmpContext from 'utils/AmpContext';

type Props = {
  children: ReactNode;
};
// eslint-disable-next-line import/no-default-export
export default class NoAmp extends React.PureComponent<Props> {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/static-property-placement
  static contextType = AmpContext;

  render() {
    return (
      <AmpContext.Consumer>
        {(requestIsAmp) => {
          if (requestIsAmp) {
            return null;
          }

          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/destructuring-assignment
          return this.props.children;
        }}
      </AmpContext.Consumer>
    );
  }
}
